import client from './client'

export interface LoginParams {
  username: string
  password: string
}

export interface LoginResult {
  token: string
  user: UserInfo
}

export interface UserInfo {
  id: number
  nickname: string
  role: string
  avatar_url?: string
  coins: number
}

// 登录
export async function login(params: LoginParams): Promise<LoginResult> {
  return client.post('/api/auth/login', params)
}

// 获取当前用户信息
export async function getUserProfile(): Promise<UserInfo> {
  return client.get('/api/user/profile')
}

// 退出登录（前端清理）
export function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
}
